import type { Product, ProductListData, ProductListParams } from '@/libs/interfaces'

import { mockProducts } from '../fixtures/products'
import { MOCK_ORG_ID } from '../fixtures/seed'
import { delay, genID, matchesSearch, paginate } from '../helpers'
import { createEntityStore } from '../store'

const productStore = createEntityStore<Product, 'productID'>(mockProducts, 'productID')

const filterProducts = (params?: ProductListParams): Product[] =>
  productStore
    .getAll()
    .filter((product) => (params?.storeID ? product.storeID === params.storeID : true))
    .filter((product) =>
      params?.productCategoryID ? product.productCategoryID === params.productCategoryID : true,
    )
    .filter((product) =>
      matchesSearch(product, params?.search, ['productDescription', 'productItemNumber']),
    )

export const productsApiMock = {
  list: async (params?: ProductListParams): Promise<ProductListData> => {
    const paginated = paginate(filterProducts(params), params)
    return delay({ products: paginated.data, ...paginated.pageInfo })
  },
  getById: async (params: Partial<Product>): Promise<Product> =>
    delay(productStore.getById(params.productID ?? '') ?? {}),
  create: async (data: Partial<Product>): Promise<Product> => {
    const product: Product = {
      productID: genID('product'),
      orgID: MOCK_ORG_ID,
      currency: 'SEK',
      productInventoryBalance: 0,
      ...data,
    }
    productStore.insert(product)
    return delay(product)
  },
  update: async (data: Partial<Product>): Promise<Product> => {
    const updated = data.productID ? productStore.update(data.productID, data) : undefined
    return delay(updated ?? (data as Product))
  },
  delete: async (params: Partial<Product>): Promise<void> => {
    if (params.productID) productStore.remove(params.productID)
    return delay(undefined)
  },
}
